<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconCheckmarkRound_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM4.39 8.74l2.1 2.1a.7.7 0 0 0 .99 0l4.2-4.2a.7.7 0 1 0-.99-.99L6.985 9.355 5.38 7.75a.7.7 0 1 0-.99.99Z"
        clip-rule="evenodd"
    />
</svg>
